import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import "./Breadcrumbs.scss";

const Breadcrumbs = ({
    items,
    className,
    color = "white"
}) => {
    return items && items.length > 0 &&  (
        <ul className={cn('breadcrumbs', className, {
            [`breadcrumbs_color-${color} `]: color
        })}>
            {items.map((link, index) => (
                <li key={index} className="breadcrumbs__item">
                    <a href={link.url} className="breadcrumbs__link" >
                        {link.linkText}
                    </a>
                </li>
            ))}
        </ul>
    );
};

Breadcrumbs.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        url: PropTypes.string,
        linkText: PropTypes.string
    })),
    className: PropTypes.string,
    color: PropTypes.oneOf([
        "white", "dark-grey"
    ]),
};

export default Breadcrumbs;



// WEBPACK FOOTER //
// ./src/components/Breadcrumbs/Breadcrumbs.jsx